// extracted by mini-css-extract-plugin
export var currencyInput = "_lj-1";
export var currencySymbol = "_lj-0";